const PWA_MENU_ITEM_DISPLAY_CLASS = 'pwa-install-menu-item--visible';
const PWA_BANNER_DISPLAY_CLASS = 'pwa-install-message--visible';

export default async function PWA() {
    const uuid = (typeof crypto.randomUUID === 'function')
        ? crypto.randomUUID()
        : (new Date()).getTime();

    await trackLaunch();

    const dropdown = document.querySelector('nav.context');
    const dropdownMenu = document.querySelector('nav.context > ul');
    const pwaBanner = document.getElementById('pwa-install-banner');
    const pwaAcceptButton = document.getElementById('pwa-accept-button');
    const pwaDeclineButton = document.getElementById('pwa-decline-button');
    const pwaMenuItem = document.getElementById('pwa-install-menu');

    // Check if banner had already been displayed
    const showBanner = !bannerDisplayed();

    let deferredInstallEvent;

    // Check if browser supports PWA events
    if (supportsPwa()) {
        // If PWA can be installed show the menu item;
        // Session data set after install prompt
        if (sessionStorage.getItem('show-pwa-install-menu-item') === 'true') {
            togglePwaMenuItem(true);
        }

        // Check if banner got displayed successfully
        if (showBanner) {
            setTimeout(checkIfBannerDisplayed, 5000);
        }

        listenForPwaEvents();
    } else {
        dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_UNSUPPORTED_BROWSER);
    }

    function closeDropdownMenu() {
        dropdown.style.display = 'none';
        dropdownMenu.style.display = 'none';
    }

    async function installPWA() {
        deferredInstallEvent.prompt();

        const outcome = await deferredInstallEvent.userChoice;

        if (outcome === 'accepted') {
            dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_INSTALL_ACCEPTED);
        } else {
            dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_INSTALL_DECLINED);
        }

        deferredInstallEvent = null;
    }

    pwaMenuItem.addEventListener('click', async function () {
        closeDropdownMenu();

        dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_INSTALL_MENU_ITEM_CLICKED);

        await installPWA();
    });

    pwaAcceptButton.addEventListener('click', async function () {
        togglePwaBanner();

        dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_INSTALL_BANNER_ACCEPT_BUTTON_CLICKED);

        await installPWA();
    });

    pwaDeclineButton.addEventListener('click', async function () {
        togglePwaBanner();

        dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_INSTALL_BANNER_DECLINE_BUTTON_CLICKED);
    });

    async function trackLaunch() {
        if (sessionStorage.getItem('launch-tracked') === 'true') {
            return;
        }

        if (window.matchMedia('(display-mode: standalone)').matches) {
            dispatchMixpanelTrackingEvent(PMCMixpanel.productLaunchEvents.PRODUCT_LAUNCH_PWA, true);
        } else if ('getInstalledRelatedApps' in window.navigator) {
            const relatedApps = await navigator.getInstalledRelatedApps();

            if (relatedApps.length > 0) {
                dispatchMixpanelTrackingEvent(PMCMixpanel.productLaunchEvents.PRODUCT_LAUNCH_PWA, true);
            } else {
                dispatchMixpanelTrackingEvent(PMCMixpanel.productLaunchEvents.PRODUCT_LAUNCH_WEB, true);
            }
        } else {
            dispatchMixpanelTrackingEvent(PMCMixpanel.productLaunchEvents.PRODUCT_LAUNCH_WEB, true);
        }

        sessionStorage.setItem('launch-tracked', 'true');
    }

    /**
     * @param {string} event
     * @param {boolean=} dispatchAsGlobalEvent
     * @see PWA_INSTALL_BANNER_DISPLAYED
     * @see PWA_INSTALL_BANNER_ACCEPT_BUTTON_CLICKED
     * @see PWA_INSTALL_BANNER_DECLINE_BUTTON_CLICKED
     * @see PWA_INSTALL_MENU_ITEM_CLICKED
     * @see PWA_INSTALL_ACCEPTED
     * @see PWA_INSTALL_DECLINED
     * @see PWA_INSTALLED
     * @see PWA_UNSUPPORTED_BROWSER
     * @see PWA_BANNER_NOT_DISPLAYED
     * @see PWA_PAGE_CLOSED_BEFORE_BANNER
     * @see PRODUCT_LAUNCH_PWA
     * @see PRODUCT_LAUNCH_WEB
     */
    function dispatchMixpanelTrackingEvent(event, dispatchAsGlobalEvent = false) {
        if (dispatchAsGlobalEvent) {
            PMCMixpanel.track(event, {
                session_id: uuid,
            });
        } else {
            PMCMixpanel.track(PMCMixpanel.pwaEvent, {
                session_id: uuid,
                event_type: event,
            });
        }
    }

    function togglePwaMenuItem(open = false) {
        pwaMenuItem.classList.toggle(PWA_MENU_ITEM_DISPLAY_CLASS, open);
    }

    /**
     * Toggle banner and optionally clear the timeout on banner close
     * @param {boolean=} open
     */
    function togglePwaBanner(open = false) {
        pwaBanner.classList.toggle(PWA_BANNER_DISPLAY_CLASS, open);
    }

    function supportsPwa() {
        return typeof window.onbeforeinstallprompt !== 'undefined' && typeof window.onappinstalled !== 'undefined';
    }

    function listenForPwaEvents() {
        // Indicate if page had been closed before banner could be displayed
        if (showBanner) {
            window.addEventListener('beforeunload', logPageCLoseBeforeBanner);
        }

        window.addEventListener('beforeinstallprompt', function (event) {
            event.preventDefault();

            togglePwaMenuItem(true);

            // Indicate that the menu item should be displayed across the pages
            sessionStorage.setItem('show-pwa-install-menu-item', 'true');

            if (showBanner) {
                togglePwaBanner(true);

                deferredInstallEvent = event;

                dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_INSTALL_BANNER_DISPLAYED);

                // Indicate that the banner had been displayed
                sessionStorage.setItem('displayed-pwa-install-banner', 'true');

                window.removeEventListener('beforeunload', logPageCLoseBeforeBanner);
            }
        });

        window.addEventListener('appinstalled', function () {
            console.log(`PWA installed`);

            togglePwaBanner();
            togglePwaMenuItem();

            // Hide menu item after app is installed
            sessionStorage.removeItem('show-pwa-install-menu-item');

            dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_INSTALLED);
        });
    }

    function checkIfBannerDisplayed() {
        if (!bannerDisplayed()) {
            dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_BANNER_NOT_DISPLAYED);
        }
    }

    function bannerDisplayed() {
        return sessionStorage.getItem('displayed-pwa-install-banner') === 'true';
    }

    function logPageCLoseBeforeBanner() {
        dispatchMixpanelTrackingEvent(PMCMixpanel.pwaEvents.PWA_PAGE_CLOSED_BEFORE_BANNER);
    }
}
